declare global {
  interface Window {
    ENV?: {
      VITE_BASE_API_URL: string;
      VITE_HTTPS: string;
      VITE_BASE_WEBSOCKET_URL: string;
    };
    gtag?: (...args: unknown[]) => void;
  }
}

// Runtime configuration object.
// window.ENV.* (runtime from Parameter Store via env.js) > import.meta.env.* (build-time Vite env vars) > Default value
export const config = {
  get baseApiUrl(): string {
    if (typeof window !== 'undefined' && window.ENV?.VITE_BASE_API_URL) {
      return window.ENV.VITE_BASE_API_URL;
    }
    if (import.meta.env.VITE_BASE_API_URL) {
      return import.meta.env.VITE_BASE_API_URL;
    }
    return 'http://localhost:8000/api';
  },
  get baseWebSocketUrl(): string {
    if (typeof window !== 'undefined' && window.ENV?.VITE_BASE_WEBSOCKET_URL) {
      return window.ENV.VITE_BASE_WEBSOCKET_URL;
    }
    if (import.meta.env.VITE_BASE_WEBSOCKET_URL) {
      return import.meta.env.VITE_BASE_WEBSOCKET_URL;
    }
    return 'ws://localhost:8000/ws';
  },

  get https(): boolean {
    let value: string;
    if (typeof window !== 'undefined' && window.ENV?.VITE_HTTPS) {
      value = window.ENV.VITE_HTTPS;
    } else {
      value = import.meta.env.VITE_HTTPS || 'false';
    }
    return value === 'true';
  },
};
